import {
    ChangeEvent,
    ClickEvent,
    DataSourceAction,
    DataSourceExecutionEvent,
    DataSourceMode,
    LookupModelSearchEvent,
    TableRow,
    TableRowDisplayEvent,
    Textbox
} from "@mcleod/components";
import {Api, DateUtil, StringUtil} from "@mcleod/core";
import {AutogenLayoutTriumphPayControl} from "./autogen/AutogenLayoutTriumphPayControl";
import {ImageName} from "@mcleod/images";


export class TriumphPayControl extends AutogenLayoutTriumphPayControl {

    onLoad(): void | Promise<void> {
        this.labelAuthorizedStatus.visible = false;
    }

    buttonGenerateTokenOnClick(event: ClickEvent) {
        window.open("https://secure.triumphpay.com/account/mcleod", '_blank');
    }

    async buttonAuthorizeOnClick(event: ClickEvent) {
        const response = await Api.post("lme/dispatch/authenticate-triumphpay");
        this.setUpAuthLabel(response.data[0]?.success);
    }

    tableTriumphPayFieldListOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();
        const textboxTableName = tableRow.findComponentById("textboxTableName") as Textbox;
        const textboxFieldName = tableRow.findComponentById("textboxFieldName") as Textbox;
        const textboxFilterFieldName = tableRow.findComponentById("textboxFilterFieldName") as Textbox;
        const textboxFilterFieldValue = tableRow.findComponentById("textboxFilterFieldValue") as Textbox;
        const textboxReferenceField = tableRow.findComponentById("textboxReferenceField") as Textbox;
        const switchIsActive = tableRow.findComponentById("switchIsActiveFieldList");
        const textboxTransactionType = tableRow.findComponentById("textboxTriumphpayTransactionType") as Textbox;

        if (tableRow === this.tableTriumphPayFieldList.quickAddRow) {
            textboxFieldName.enabled = false;
            textboxFilterFieldName.enabled = false;
            textboxFilterFieldValue.enabled = false;
            textboxReferenceField.enabled = false;

            textboxTransactionType.tooltip = "Type of data to be sent to Triumph when additions or updates occur to this field";
            textboxTableName.tooltip = "Database table name for changes to be sent to Triumph";
            textboxFieldName.tooltip = "Database field name for changes to be sent to Triumph";
            textboxFilterFieldName.tooltip = "Database field name to use as filter for changes to be sent to Triumph";
            textboxFilterFieldValue.tooltip = "Pipe separated list of database field values used to filter changes to be sent to Triumph";
            textboxReferenceField.tooltip = "Database field name to use as ID for table cross-referencing for movements, orders, and payees";
            switchIsActive.tooltip = "Mark checkbox to indicate this field is active";
        }

        this.updateTextboxEnabledStates(tableRow);
    }

textboxTableNameOnLookupModelSelection(event: LookupModelSearchEvent) {
    const textboxTableName = event.target as Textbox;
    this.updateTextboxEnabledStates(TableRow.getContainingTableRow(textboxTableName));
}

    /**
     * Updates the enabled state of field-related textboxes based on whether
     * a table name has been selected
     */
    private updateTextboxEnabledStates(tableRow: TableRow): void {
        const textboxFieldName = tableRow.findComponentById("textboxFieldName") as Textbox;
        const textboxFilterField = tableRow.findComponentById("textboxFilterFieldName") as Textbox;
        const textboxReferenceField = tableRow.findComponentById("textboxReferenceField") as Textbox;
        const textboxTableName = tableRow.findComponentById("textboxTableName") as Textbox;

        if (textboxFieldName != null) {
            const isEnabled = !StringUtil.isEmptyString(textboxTableName?.text);

            textboxFieldName.enabled = isEnabled;

            if (textboxFilterField != null) {
                textboxFilterField.enabled = isEnabled;
            }

            if (textboxReferenceField != null) {
                textboxReferenceField.enabled = isEnabled;
            }
        }
    }

    private setFieldLookupFilter(event: LookupModelSearchEvent) {
        // Attempt to get the table name from the textboxTableName property
        const tableRow = TableRow.getContainingTableRow(event.target as Textbox);
        const textboxTableName = tableRow.findComponentById("textboxTableName") as Textbox;

        if (StringUtil.isEmptyString(textboxTableName?.text)) {
            event.filter = null;
        } else {
            event.filter.table_name = textboxTableName.text;
        }
    }

    textboxFieldNameBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        this.setFieldLookupFilter(event);
    }

    textboxFilterFieldBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        this.setFieldLookupFilter(event);
    }

    textboxReferenceFieldBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        this.setFieldLookupFilter(event);
    }

    sourceTriumphpayFieldListBeforeExecution(event: DataSourceExecutionEvent) {
        if (event.getAction() === DataSourceAction.SEARCH) {
            event.filter.override_search = true
        }
    }

    switchIsActiveOnChange(event: ChangeEvent) {
        if (event.userInitiatedChange) {
            if(event.newValue && StringUtil.isEmptyString(this.textboxLastUpdate.text)){
                const now = new Date();
                this.textboxLastUpdate.text = DateUtil.formatDateTime(now);
            }
        }
    }

    textboxRefreshTokenOnChange(event: ChangeEvent) {
        this.buttonAuthorize.visible = this.hasRequiredFields();
}
    textboxVendorUrlOnChange(event: ChangeEvent) {
        this.buttonAuthorize.visible = this.hasRequiredFields();
    }

    textboxClientIdOnChange(event: ChangeEvent) {
        this.buttonAuthorize.visible = this.hasRequiredFields();
    }

    textboxClientSecretOnChange(event: ChangeEvent) {
        this.buttonAuthorize.visible = this.hasRequiredFields();
    }


    private hasRequiredFields() {
        return !StringUtil.isEmptyString(this.textboxVendorUrl.text)
            && !StringUtil.isEmptyString(this.textboxClientId.text)
            && !StringUtil.isEmptyString(this.textboxClientSecret.text)
            && !StringUtil.isEmptyString(this.textboxRefreshToken.text);
    }

    private setUpAuthLabel(success: any) {
        this.labelAuthorizedStatus.visible = true;
        if(success){
            this.labelAuthorizedStatus.imageName = ImageName.circleCheck;
            this.labelAuthorizedStatus.imageColor = "success";
        }else{
            this.labelAuthorizedStatus.imageName = ImageName.circleX;
            this.labelAuthorizedStatus.imageColor = "error";
        }
    }
}

